// extracted by mini-css-extract-plugin
export default {"ecospendBackLink":"IioFkFm6KZ4wf2bHfQ4X"};